











import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import { formatDate } from '@/utils';

declare var $: any;

@Component({
    components: {}
})
export default class DatepickerComponentFull extends Vue {
    @Prop() public value: Date;
    @Prop() public minValidDate: Date;

    get periodStr() {
        if (!this.value) {
            return '';
        }
        return formatDate(this.value);
    }

    public mounted() {
        this.$nextTick(() => {
            const el: any = $(this.$el);
            const options = {
                isInvalidDate: (date: Date) => {
                    if (!this.minValidDate) {
                        return false;
                    }
                    return date < this.minValidDate;
                },
                singleDatePicker: true,
                startDate: this.value,
                showDropdowns: true,
                minYear: (new Date()).getFullYear() - 10,
                maxYear: (new Date()).getFullYear() + 10,
                autoApply: true,
                parentEl: el,
            };
            el.daterangepicker(options);
            el.on('apply.daterangepicker', (event, picker) => {
                const start = picker.startDate.startOf('date').toDate();
                this.input(start);
            });
            el.data('daterangepicker').hide = (): void => {
                //
            };
            el.data('daterangepicker').show();
        });
    }

    @Watch('value')
    public onValueChange(value) {
        if (!value) {
            return;
        }
        $(this.$el)
            .data('daterangepicker')
            .setStartDate(value);
        // $(this.$el).data('daterangepicker').hide();
        // $(this.$el).data('daterangepicker').show();
    }

    public beforeDestroy() {
        $(this.$el)
            .daterangepicker('hide')
            .daterangepicker('destroy');
    }

    @Emit()
    public input($val) {
        // raise input
    }
}
